import { Buttons, Text } from '@taxdown/piccolo-web';
import { useTranslation } from 'react-i18next';
import { locizeNS } from 'Services/i18n';
import { lottiesPaths } from 'Constants/lottiesPaths';
import * as Styled from './styles';
import { ErrorPageProps } from './types';

const ErrorPage = ({
  inView = false,
  headerText = 'Error.boundary.title',
  description = '',
  helpText = 'Error.boundary.text',
  CTALabel = 'Error.boundary.CTA',
  onError,
}: ErrorPageProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.ERROR);

  return (
    <Styled.Container align="center" justify="center" fullHeight $inView={inView}>
      <Styled.Lottie options={{ path: lottiesPaths.ERROR_LOTTIE }} />
      <Styled.Content>
        <Text tag="h2" type="headline" size="M_L_L" mb="dimension_18" color="dark">
          {t(headerText)}
        </Text>
        {description && (
          <Text tag="h3" type="headline" size="S_L_L" color="success_strong" mb="dimension_18">
            {t(description)}
          </Text>
        )}
        <Text type="paragraphs" size="M_M_S" color="dark" mb="dimension_18">
          {t(helpText)}
        </Text>
        {onError && (
          <Buttons.Button size="l" mode="primary" onClick={onError} label={t(CTALabel)} />
        )}
      </Styled.Content>
    </Styled.Container>
  );
};

export default ErrorPage;
